import { AuthService } from 'src/app/Services/auth.service';
import { TokenService } from 'src/app/Services/token.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {
  currentDate: Date = new Date();

  // * show login/logout button
  loggedIn: boolean = false;

  constructor(
    private tokenService: TokenService,
    public router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // * check if user is logged in
    this.loggedIn = this.tokenService.loggedIn();

    // * refresh time per second
    setInterval(() => {
      this.currentDate = new Date();
    });
  }

  logout() {
    this.authService.logout();
  }
  myProfile() {
    const role = localStorage.getItem('role');
    switch (+role) {
      case 1: {
        this.router.navigateByUrl('/admin/user-management');
        break;
      }
      case 2: {
        this.router.navigateByUrl('/super-admin');
        break;
      }
      case 3: {
        this.router.navigateByUrl('/expert');
        break;
      }
      case 4: {
        this.router.navigateByUrl('/moderator');
        break;
      }
      case 5: {
        this.router.navigateByUrl('/institute');
        break;
      }
      case 6: {
        this.router.navigateByUrl('/student/basic-details');
        break;
      }
      case 7: {
        this.router.navigateByUrl('/hod');
        break;
      }
      case 8: {
        this.router.navigateByUrl('/faculty');
        break;
      }
      case 9: {
        this.router.navigateByUrl('/finance');
        break;
      }
      case 10: {
        this.router.navigateByUrl('/nodal-officer');
        break;
      }
      case 11: {
        this.router.navigateByUrl('/consultant');
        break;
      }
      default: {
        this.authService.logout();
      }
    }
  }
}
